module.exports = __webpack_public_path__ + "static/img/09.0a6a59c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/09.png
// module id = OOUY
// module chunks = 1